import { RootState } from 'src/root/store';

import { reportsModuleSel } from '../common';

export { reportsSel, reportsByCodesSel } from '../basicReports';

export const activeTabSel = (state: RootState) =>
  reportsModuleSel(state).activeTab;
export const reportParamsVisibleSel = (state: RootState) =>
  reportsModuleSel(state).reportParamsVisible;
export const reportParamsDataSel = (state: RootState) =>
  reportsModuleSel(state).reportParamsData;
